import axios, { AxiosError } from 'axios'
import { useQuery } from 'react-query'

import { BirthdayQuote, BirthdayQuoteRequest } from '@facades/birthday'
import { getEndpoint } from '@utils/getEndpoint'

const fetchBirthdayQuote = async (
  request: BirthdayQuoteRequest
): Promise<BirthdayQuote> => {
  const response = await axios.post<BirthdayQuote>(
    `${getEndpoint()}/birthday/quote`,
    request
  )
  return response.data
}

export const useBirthdayQuote = (
  request: BirthdayQuoteRequest,
  enabled: boolean
) => {
  const query = useQuery<BirthdayQuote, AxiosError>(
    ['birthday', 'quote', request],
    () => fetchBirthdayQuote(request),
    { enabled }
  )

  return {
    ...query,
    data: enabled ? query.data : undefined,
  }
}
